
import { Helmet } from 'react-helmet';
import headerImage from "../../assets/staticSection/azienda_sede.webp";
import { Link } from 'react-router-dom';
import { ScrollParallax } from 'react-just-parallax';
import { SlArrowDown } from 'react-icons/sl';
import { useRef } from 'react';
import lingottoVero from "../../assets/lingotti/lingotto_vero.webp";
import lingottoFalso from "../../assets/lingotti/lingotto_falso1.png";

export default function Affidabilita() {


    const nextSectionRef = useRef(null);

    // Function to scroll to the next section
    const scrollToNextSection = () => {
        nextSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    return (
        <div>
            <Helmet>
                <title>Careisgold è affidabile? Risposte chiare, verificabili e senza filtri</title>
                <meta name="description" content="Chi cerca chiarezza su Careisgold non cerca chiacchere. Cerca fatti verificabili, per orientarsi senza lasciarsi condizionare da dicerie." />
                <meta property="og:image" content={headerImage} />
                <meta property="og:title" content="Careisgold è affidabile? Risposte chiare, verificabili e senza filtri" />
                <meta property="og:description" content="Chi cerca chiarezza su Careisgold non cerca chiacchere. Cerca fatti verificabili, per orientarsi senza lasciarsi condizionare da dicerie." />
                <meta property="og:url" content="https://www.careisgold.it/fare-chiarezza/" />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://www.careisgold.it/fare-chiarezza/" />
                <script type="application/ld+json">
                    {`
                        {
                            "@context": "https://schema.org",
                            "@type": "FAQPage",
                            "mainEntity": [
                                {
                                    "@type": "Question",
                                    "name": "Perché alcune persone cercano Careisgold truffa?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "Perché è normale, prima di prendere una decisione, cercare anche gli scenari peggiori. È un comportamento prudente. Chi lo fa sta facendo la cosa giusta: informarsi prima di agire."
                                    }
                                },
                                {
                                    "@type": "Question",
                                    "name": "Come posso capire se un operatore è affidabile?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "Osservando la chiarezza del processo, la verificabilità delle informazioni e l'assenza di pressione."
                                    }
                                },
                                {
                                    "@type": "Question",
                                    "name": "È possibile approfondire Careisgold senza impegno?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "Sì. L'approfondimento serve proprio a comprendere, non a decidere in modo forzato."
                                    }
                                }
                            ]
                        }
                    `}
                </script>
            </Helmet>
            <main>
                <div>
                    <div className='relative z-20 h-lvh overflow-hidden bg-black'>
                        <ScrollParallax enableOnTouchDevice={true} isAbsolutelyPositioned={true} lerpEase="0.05">
                            <img src={headerImage} alt='background' className="absolute top-0 left-0 w-full h-full object-cover" />
                        </ScrollParallax>
                        <div className='absolute top-0 left-0 w-full h-full bg-black bg-opacity-70 md:bg-opacity-30' />
                        <div className="absolute top-0 left-0 bg-black bg-opacity-30 md:bg-opacity-30 w-full h-full flex justify-center">
                            <div className="flex justify-center items-center text-start ps-15 mx-5 md:mr-[20%] xl:ml-[45%]">
                                <div className='lg:w-[100%]'>
                                    <div className="text-xl sm:text-2xl md:text-5xl text-white drop-shadow-2xl font-semibold text-balance" data-aos="fade-up" data-aos-duration="1000" >
                                        <h1>
                                            Careisgold è affidabile? Risposte chiare, verificabili e senza filtri
                                        </h1>
                                    </div>
                                    <div className="sm:text-lg md:text-xl  mt-4 mb-10 text-white drop-shadow-2xl text-balance" data-aos="fade-up" data-aos-duration="1000">
                                        <p>
                                            Quando si parla di oro fisico, è normale porsi delle domande. Soprattutto online, dove convivono informazioni corrette, opinioni personali e contenuti fuori contesto.
                                            Chi cerca chiarezza non cerca chiacchiere. Cerca fatti verificabili.
                                            Questa pagina nasce per questo: offrire risposte concrete, attendibili.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <SlArrowDown
                                data-aos="fade-up"
                                data-aos-delay="600"
                                data-aos-duration="1000"
                                onClick={scrollToNextSection}
                                className='arrow cursor-pointer block absolute transform -translate-x-1/2 text-slate-50 text-3xl md:text-5xl' />
                        </div>
                    </div>
                    <div ref={nextSectionRef} />
                </div>
                <div className='flex relative z-20 bg-white'>
                    <div className='w-1/4 sticky top-24 self-start mt-24 hidden sm:block '>
                        <p className='text-black font-semibold uppercase text-xs sm:text-base'>Lingotto Vero</p>
                        <img src={lingottoVero} alt="Lingotto vero" />
                    </div>

                    <div className='w-full sm:w-2/4 mx-auto relative'>

                        {/* VERSIONE LINGOTTI MOBLIE */}
                        <div className='sm:hidden flex items-center z-20 h-72 sticky top-0 self-start pt-5 bg-gradient-to-b from-white from-[80%] to-transparent'>
                            <div className='w-1/2'>
                                <img
                                    src={lingottoVero}
                                    alt='Lingotto vero'
                                />
                            </div>
                            <div className='w-1/2'>
                                <img
                                    src={lingottoFalso}
                                    alt='Lingotto falso'
                                />
                            </div>
                        </div>
                        {/* /VERSIONE LINGOTTI MOBLIE */}

                        <section className="w-full text-black">
                            <div className="max-w-4xl mx-auto pt-32 pb-10 px-5  text-start">
                                <h2 className="text-xl sm:text-3xl font-bold">Come riconoscere una reale situazione di rischio</h2>
                                <p className='text-sm sm:text-base mt-5 font-semibold'>Prima di affidarsi a qualsiasi operatore, è utile capire quali sono i segnali da osservare.</p>
                                <p className='text-sm sm:text-base mt-5'>Una situazione poco trasparente presenta spesso:</p>
                                <ul className="text-sm sm:text-base space-y-5 mt-5 list-disc list-inside">
                                    <li>
                                        informazioni incomplete o difficili da verificare
                                    </li>
                                    <li>
                                        prezzo poco chiaro o non dettagliato
                                    </li>
                                    <li>
                                        assenza di riferimenti a standard internazionali
                                    </li>
                                    <li>
                                        comunicazione focalizzata su urgenza o pressione
                                    </li>
                                    <li>
                                        difficoltà nel ricostruire il percorso del bene acquistato
                                    </li>
                                </ul>
                                <p className='text-sm sm:text-base mt-5'>Quando manca chiarezza, il rischio non è solo nel prodotto, ma anche nel processo.</p>
                            </div>
                        </section>

                        <section className="w-full text-black">
                            <div className="max-w-4xl mx-auto py-10 px-5  text-start">
                                <h2 className="text-xl sm:text-3xl font-bold">Come funziona Careisgold</h2>
                                <p className='text-sm sm:text-base mt-5 font-semibold'>Careisgold si basa su un principio semplice: rendere ogni passaggio comprensibile.</p>
                                <p className='text-sm sm:text-base mt-5'><strong>Filiera:</strong> l'oro fisico proposto rispetta standard internazionali riconosciuti, tra cui Good Delivery e circuiti LBMA.</p>
                                <p className='text-sm sm:text-base mt-5'><strong>Prezzo:</strong> il prezzo è sempre espresso in modo trasparente, con indicazione chiara delle componenti.</p>
                                <p className='text-sm sm:text-base mt-5'><strong>Processo:</strong> ogni operazione segue un percorso definito, tracciabile e chiaro.</p>
                                <p className='text-sm sm:text-base mt-5'><strong>Approfondimento:</strong> chi desidera comprendere meglio può accedere a momenti di approfondimento.</p>

                            </div>
                        </section>

                        <section className="w-full text-black">
                            <div className="max-w-4xl mx-auto py-10 px-5  text-start">
                                <h2 className="text-xl sm:text-3xl font-bold"> Careisgold è una truffa?</h2>
                                <p className='text-sm sm:text-base mt-5'>No.</p>
                                <p className='text-sm sm:text-base mt-5'>Careisgold è una realtà strutturata che opera seguendo standard riconosciuti e processi verificabili.</p>
                                <p className='text-sm sm:text-base mt-5'>Il dubbio nasce spesso da un meccanismo naturale: quando un tema è complesso, le persone cercano conferme anche attraverso ricerche online, associando il termine ad altre parole, come “recensioni” o anche parole forti come "truffa". È un comportamento comprensibile.</p>
                                <p className='text-sm sm:text-base mt-5'>Per questo la risposta non è una promessa, ma la possibilità di verificare ogni aspetto.</p>

                            </div>
                        </section>

                        <section className="w-full text-black">
                            <div className="max-w-4xl mx-auto py-10 px-5  text-start">
                                <h2 className="text-xl sm:text-3xl font-bold"> Perché online possono comparire dubbi o associazioni errate</h2>
                                <p className='text-sm sm:text-base mt-5'>Le piattaforme digitali funzionano per associazioni di parole, non per verifica del contenuto.</p>

                                <p className='text-sm sm:text-base mt-5'>Questo significa che:</p>
                                <ul className="text-sm sm:text-base space-y-5 mt-5 list-disc list-inside">
                                    <li className='text-sm sm:text-base'>
                                        contenuti non correlati possono essere aggregati insieme
                                    </li>
                                    <li>
                                        una parola può essere usata fuori contesto
                                    </li>
                                    <li>
                                        algoritmi possono accostare elementi senza relazione reale
                                    </li>
                                </ul>
                                <p className='mt-5 text-sm sm:text-base'>Per questo motivo, il modo corretto per orientarsi non è fermarsi al titolo, ma analizzare i fatti.</p>
                            </div>
                        </section>

                        <section className="w-full text-black">
                            <div className="max-w-4xl mx-auto py-10 px-5  text-start">
                                <h2 className="text-xl sm:text-3xl font-bold"> Trasparenza: cosa puoi verificare — e dove</h2>
                                <p className='mt-5 text-sm sm:text-base'>Chiunque può verificare. Non in modo generico: con fonti precise, pubbliche e gratuite.</p>

                                <p className='mt-5 text-sm sm:text-base'><strong>Iscrizione al Registro OAM</strong> Dal 17 aprile 2025, in base al D.Lgs. n. 211/2024, tutti gli Operatori Professionali in Oro in Italia devono essere iscritti nel Registro OPO tenuto dall'OAM (organo sottoposto a vigilanza da parte di Banca d’Italia). Chi non è iscritto e opera commette reato di esercizio abusivo. Careisgold è iscritta con numero <strong>OPO6</strong>. </p>

                                <p className='mt-5 text-sm sm:text-base'> Verifica diretta su: <Link to="https://www.organismo-am.it/elenchi-registri/opo/" target="_blank" rel="noopener noreferrer" className='text-blue-600 hover:underline font-bold'>organismo-am.it/elenchi-registri/opo</Link></p>

                                <p className='mt-5 text-sm sm:text-base'> La pagina ufficiale di <Link to="https://www.bancaditalia.it/media/notizia/modifiche-alla-disciplina-del-mercato-dell-oro-in-italia/" target="_blank" rel="noopener noreferrer" className='text-blue-600 hover:underline font-bold'>Banca d'Italia</Link> spiega il passaggio di competenze, confermando la legittimità del nuovo sistema OAM.</p>

                                <p className='mt-5 text-sm sm:text-base'>Infatti, nell’anno 2019, Careisgold, ai sensi dell'art.1, c.3 della Legge 17 gennaio 2000, n.7, ha effettuato la comunicazione a Banca d’Italia per l'esercizio in via professionale del commercio in oro. È possibile trovare Careisgold iscritta anche al vecchio elenco OPO — con codice <Link to="https://infostat.bancaditalia.it/GIAVAInquiry-public/oro.html" target="_blank" rel="noopener noreferrer" className='text-blue-600 hover:underline font-bold'>operatore n° 5008578 sul sito di Banca d’Italia.</Link> </p>

                                <p className='mt-5 text-sm sm:text-base'><strong>Lingotti certificati:</strong> i lingotti commerciati da Careisgold sono in oro puro 24k con purezza 999,9‰ prodotti dalla raffineria Argor Heraeus, inserita nella Good Delivery List che garantisce il rispetto dello standard internazionale di riferimento per purezza, peso e tracciabilità. Ogni lingotto ha un numero seriale univoco.</p>

                                <p className='mt-5 text-sm sm:text-base'><strong>Licenza di Pubblica Sicurezza</strong> Per il commercio di oro fisico, la legge richiede una Licenza di Pubblica Sicurezza rilasciata dalla Questura, che presuppone verifiche sui requisiti di onorabilità di soci, amministratori e responsabili commerciali.<strong>Careisgold</strong> è titolare di Licenza di Pubblica Sicurezza rilasciata dalla Questura per la distribuzione di Oro Puro Fisico da investimento.</p>

                                <p className='mt-5 text-sm sm:text-base'><strong>Forma giuridica e capitale sociale</strong> La L. 7/2000 consente il commercio professionale di oro solo a SpA, SapA, Srl o cooperative con capitale interamente versato. Careisgold SpA ha capitale sociale interamente versato pari a <strong>€ 2.000.000</strong>, nell'ambito del Gruppo Care Holding SpA attivo da oltre 13 anni.</p>

                                <p className='mt-5 text-sm sm:text-base'><strong>Assenza di rendimenti garantiti</strong>  L'oro fisico non produce interessi. Qualsiasi operatore che promette un rendimento — dell'1%, del 4% mensile o di qualsiasi altra percentuale — sta facendo qualcosa di fondamentalmente scorretto. Careisgold non propone rendimenti garantiti. L'oro è presentato per ciò che è: un bene rifugio, in grado di proteggere il valore del potere d’acquisto. La trasparenza non è una dichiarazione. È la possibilità di controllare.</p>
                            </div>
                        </section>

                        <section className="w-full text-black">
                            <div className="max-w-4xl mx-auto py-10 px-5  text-start">
                                <h2 className="text-xl sm:text-3xl font-bold">Come verificare velocemente</h2>
                                <ul className="text-sm sm:text-base space-y-5 mt-5 list-decimal list-inside">
                                    <li>
                                        Vai su  <Link to="https://www.organismo-am.it/elenchi-registri/opo/" target="_blank" rel="noopener noreferrer" className='text-blue-600 hover:underline font-bold'>organismo-am.it/elenchi-registri/opo</Link> e cerca "Careisgold" — troverai l'iscrizione attiva con numero OPO6.
                                    </li>
                                    <li>
                                        Cerca Careisgold nel registro storico di Banca d'Italia — ancora consultabile su <Link to="https://infostat.bancaditalia.it/GIAVAInquiry-public/oro.html" target="_blank" rel="noopener noreferrer" className='text-blue-600 hover:underline font-bold'> bancaditalia.it</Link>  — troverai il codice operatore n°5008578, iscrizione del 2019.
                                    </li>
                                    <li>
                                        Rileggi qualsiasi proposta ricevuta: se compare la parola "rendimento garantito", fermati. Nessun operatore serio la usa — perché l'oro fisico non produce interessi.
                                    </li>
                                </ul>
                            </div>
                        </section>

                        <section className="w-full text-black">
                            <div className="max-w-4xl mx-auto py-10 px-5  text-start">
                                <h2 className="text-xl sm:text-3xl font-bold">Domande frequenti</h2>
                                <dl className="text-sm sm:text-base space-y-6 mt-5">

                                    <div>
                                        <dt className="font-semibold text-lg">
                                            Perché alcune persone cercano "Careisgold truffa"?
                                        </dt>
                                        <dd className="mt-2 ">
                                            Perché è normale, prima di prendere una decisione, cercare anche gli scenari peggiori. È un comportamento prudente.
                                        </dd>
                                    </div>

                                    <div>
                                        <dt className="font-semibold text-lg">
                                            Come posso capire se un operatore è affidabile?
                                        </dt>
                                        <dd className="mt-2 ">
                                            Osservando la chiarezza del processo, la verificabilità delle informazioni e l'assenza di pressione.
                                        </dd>
                                    </div>

                                    <div>
                                        <dt className="font-semibold text-lg">
                                            È possibile approfondire senza impegno?
                                        </dt>
                                        <dd className="mt-2 ">
                                            Sì. L'approfondimento serve proprio a comprendere, non a decidere in modo forzato.
                                        </dd>
                                    </div>

                                </dl>
                                <p className="text-sm sm:text-base mt-10 italic">
                                    La fiducia non si chiede. Si costruisce rendendo tutto comprensibile.
                                    Il resto è verificabile.
                                </p>
                            </div>
                        </section>
                    </div>

                    <div className='w-1/4 sticky top-24 self-start mt-24 hidden sm:block'>
                        <p className='text-black font-semibold uppercase text-xs sm:text-base'>Lingotto Falso</p>
                        <img src={lingottoFalso} alt="Lingotto falso" />
                    </div>
                </div>
            </main>
        </div>
    );
}